import { MODIFY_INVOICE, MODIFY_INVOICE_ITEM_VALUE } from '../actions/actionTypes'

const initialState = {
	modifiedValues: {
		items: [],
	},
}

const reducer = (state = initialState, action) => {
	switch (action.type) {
	case MODIFY_INVOICE:
		return {
			...state,
			modifiedValues: {
				...state.modifiedValues,
				[action.payload.key]: action.payload.value,
			},
		}
	case MODIFY_INVOICE_ITEM_VALUE:
		return {
			...state,
			modifiedValues: {
				items: state.modifiedValues.items.concat(action.payload),
			},
		}
	default:
		return state
	}
}

export default reducer
